import styled from 'styled-components';

export const Label = styled.div`
	font-size: 12px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
	margin-bottom: 10px;
`;

export const HeaderBase = styled.div`
	padding-left: 12px;
	padding-right: 10px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: transparent;
	padding-top: 8px;
	padding-bottom: 6px;
`;

export const HeaderLabel = styled.div`
	// layout
	display: flex;
	align-items: center;
	margin-bottom: 0px;
	margin-top: 0px;

	// style
	user-select: none;
	font-size: 17px;
	font-family: 'Inter', sans-serif;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

export const HeaderActionsSection = styled.div`
	display: flex;
	gap: 0px;
	align-items: center;
	margin-top: 1px;
`;

// nested buttons are not allowed so we have a separate style for the dropdown trigger
export const DropdownTrigger = styled.div`
	background: transparent;
	border: none;
	border-radius: 6px;
	padding-left: 1px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const Dimensions = styled.div`
	font-size: 12px;
	font-family: 'Inter', sans-serif;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[700]};
	margin-left: 13px;
`;
